import React from 'react';
import { ImpactData } from '../../model/domain/types';
import { formatImpactValue } from '../../../utils/formatters';

interface ProjectImpactCardProps {
  impact: ImpactData;
  title?: string;
}

export function ProjectImpactCard({ impact, title = "Latest Impact Data" }: ProjectImpactCardProps) {
  return (
    <div className="rounded-lg bg-surface-700 p-6 shadow border border-border">
      <h2 className="text-lg font-medium text-quantum-400 mb-3">
        {title}
      </h2>
      <div className="grid grid-cols-4 gap-4">
        <div>
          <span className="text-sm text-text-muted">Capacity</span>
          <p className="text-lg font-medium text-text-primary">{formatImpactValue(impact.mwCapacity, 'capacity')}</p>
        </div>
        <div>
          <span className="text-sm text-text-muted">Health Impact</span>
          <p className="text-lg font-medium text-health-400">{formatImpactValue(impact.dalys, 'dalys')}</p>
        </div>
        <div>
          <span className="text-sm text-text-muted">Biodiversity Impact</span>
          <p className="text-lg font-medium text-ecosystem-400">{formatImpactValue(impact.pdfs, 'pdfs')}</p>
        </div>
        <div>
          <span className="text-sm text-text-muted">Economic Impact</span>
          <p className="text-lg font-medium text-economic-400">{formatImpactValue(impact.economic, 'economic')}</p>
        </div>
      </div>
    </div>
  );
}